import React from "react";
import { useHistory } from "react-router-dom";
import "../styles/unknowncrash.css";

const UnknownCrash = ({ crashReference = "I_V_1" }) => {
  const history = useHistory();
  return (
    <div className="something-went-wrong-container">
      <div className="something-went-wrong-title" data-testid="something-went-wrong">
        <h1>Oops!</h1>
      </div>
      <div className="something-went-wrong-text">Something went wrong !!!</div>
      <div className="something-went-wrong-text">Reference: {crashReference}</div>
      <div className="something-went-wrong-gotohome" data-testid="gotoHomepage" onClick={() => history.push("/home")}>
        <button>Go to Home</button>
      </div>
    </div>
  );
};

export default UnknownCrash;
